import React from 'react';
import '../../../assets/css/style.css';
import RadioChipContainer from '../elements/RadioChipContainer';

const VirtuesReligion = () => {
    const religionNames = [
        'Buddhist','Jewish','Hindu','Agnostic','Catholic',
        'Christian','Muslim','Atheist','Spiritual','Other','Prefer Not to Say'
    ];

    return (
        <div className="chip-container">
            <RadioChipContainer labels={religionNames} type="religion" />
        </div>
    );
};

export default VirtuesReligion;